import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInvite: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconInvite"><Path d="M4.5 10.9706V2.5H19.5V10.9706M9.5 7.5H14.5M2.5 10.5V20.5H21.5V10.5L12 13.5L2.5 10.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconInvite;
